import { supabase } from './client';

// The generated Database types predate migration 0051, so price_history
// isn't in them — use the `as any` escape hatch the other post-snapshot
// table clients use.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

// Price history (migration 0051). RLS restricts reads to approved medical
// patients + admins, so a non-medical caller simply gets an empty array
// (no rows pass the policy) — the strain page also wraps the chart in
// MedicalStatusGate, so this is defence-in-depth, not the only gate.

export type PricePoint = {
  pharmacy_slug: string;
  price_per_gram_gbp: number;
  recorded_at: string;
};

/** Every recorded price for a strain, oldest first, across all pharmacies. */
export async function fetchPriceHistory(strainId: string): Promise<PricePoint[]> {
  const { data, error } = await db
    .from('price_history')
    .select('pharmacy_slug, price_per_gram_gbp, recorded_at')
    .eq('strain_id', strainId)
    .order('recorded_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as PricePoint[];
}
